module.exports = "/_next/static/images/Hero@2x-4b36cd455e7e83a2a0c10d99f60c82a2.webp";